import { type Step } from "../../../types";

export const intro_steps_1: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Вы подключаете кабинет к нашему сервису за 5 минут через наше приложение.",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value: "Данные ежедневно загружаются в вашу Google-таблицу.",
      },
    ],
  },
  {
    index: 3,
    content: [
      {
        type: "NoIconText",
        value:
          "Помимо наших готовых листов, вы можете кастомизировать свою Google-таблицу как угодно: добавлять новые листы, формулы, графики и собственные метрики. А мы гарантируем, что данные в ней всегда будут корректными и актуальными.",
      },
    ],
  },
];

export const intro_steps_2: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Метрики Кластеров: Заказы ДРР, CTR, CPC, CR, Видимость, Просмотры, Расход.",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value: "Аналитика по артикулам, чтобы быстро принимать решения.",
      },
    ],
  },
];

export const intro_steps_3: Step[] = [
  {
    index: 1,
    content: [
      {
        type: "NoIconText",
        value:
          "Экономит 2–3 часа в день: Больше не нужно вручную выгружать и сводить данные из разных источников.",
      },
    ],
  },
  {
    index: 2,
    content: [
      {
        type: "NoIconText",
        value: "Мобильность: Доступна через приложение Google-Таблицы.",
      },
    ],
  },
  {
    index: 3,
    content: [
      {
        type: "NoIconText",
        value: "Простота: Удобно работать в команде.",
      },
    ],
  },
  {
    index: 4,
    content: [
      {
        type: "NoIconText",
        value:
          "Концентрация на главном: Вместо рутины — анализ и стратегия для роста вашего бизнеса.",
      },
    ],
  },
  {
    index: 5,
    content: [
      {
        type: "NoIconText",
        value: "Быстрая поддержка",
      },
    ],
  },
];

export const questions = [
  {
    question: "Сколько артикулов вмещает таблица Автоджема?",
    answer: "До 30 артикулов.",
  },
  {
    question: "Можно ли менять артикулы для загрузки?",
    answer: "Да, это можно делать в любой момент.",
  },
  {
    question: "Можно ли в одном кабинете использовать несколько Автоджемов?",
    answer: "Да, в одном кабинете может быть несколько Автоджемов.",
  },
];
